import { QuietButton } from "./controls";
export type InvoiceItemKind = "service" | "equipment" | "material" | "fee" | "discount";
export function InvoiceItemActions({ disabled = false, onAdd }: { disabled?: boolean; onAdd: (kind: InvoiceItemKind) => void }) {
  return <div className="job-actions invoice-add-chips" aria-label="Add invoice items">
    {([["service", "Add service"], ["equipment", "Add equipment"], ["material", "Add materials"], ["fee", "Add fee"], ["discount", "Add discount"]] as const).map(([kind, label]) => <QuietButton key={kind} type="button" disabled={disabled} onMouseDown={event => event.preventDefault()} onClick={() => onAdd(kind)}>{label}</QuietButton>)}
  </div>;
}
